import styled from 'styled-components'

const SearchContainer = styled.div`
  display: flex;
  align-items: end;
  margin-bottom: 32px;

  > div {
    width: 76%;

    div > span {
      height: 44px;
    }
  }
  > button {
    width: 24%;
  }
`

const FooterButtons = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;

  button {
    display: block;
    width: calc(50% - 6px);
  }
`

export const s = { SearchContainer, FooterButtons }
